import { useCallback, useState } from "react";

import PageLoading from "components/loading/PageLoading";
import FullScreenModal from "ds/components/FullScreenModal";
import useTitle from "hooks/useTitle";
import useErrorHandle from "hooks/useErrorHandle";
import { showSimpleLeaveConfirmation } from "ds/components/LeaveConfirmationModal/Simple";

import useCloseFullScreenModal from "../../useCloseFullScreenModal";
import useGetAzureDevOpsIntegration from "./useGetAzureDevOpsIntegration";
import VCSIntegrationsManageAzureDevOpsForm from "../Form";

type VCSIntegrationsManageAzureDevOpsEditProps = {
  id: string;
};

const VCSIntegrationsManageAzureDevOpsEdit = ({
  id,
}: VCSIntegrationsManageAzureDevOpsEditProps) => {
  const [isDirty, setIsDirty] = useState(false);

  const { integration, isPageLoading, error } = useGetAzureDevOpsIntegration(id);
  const { handleOnClose } = useCloseFullScreenModal();

  const modalCloseClickHandler = useCallback(async () => {
    if (isDirty) {
      await showSimpleLeaveConfirmation();
    }

    handleOnClose();
  }, [handleOnClose, isDirty]);

  const toggleIsDirty = useCallback((value: boolean) => {
    setIsDirty(value);
  }, []);

  useTitle(`Edit integration · ${integration?.name}`);

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  return (
    <FullScreenModal title="Edit Azure DevOps integration" onClose={modalCloseClickHandler}>
      {isPageLoading && <PageLoading />}
      {!isPageLoading && (
        <VCSIntegrationsManageAzureDevOpsForm
          integration={integration}
          onIsDirtyChange={toggleIsDirty}
        />
      )}
    </FullScreenModal>
  );
};

export default VCSIntegrationsManageAzureDevOpsEdit;
